import { useEffect } from 'react';

// Syncs <html dir/lang> attrs from the current locale. Extracted from App.tsx
// for unit-testability without rendering the whole Refine + Router tree.
export function useHtmlDirSync(language: string | undefined): {
  direction: 'rtl' | 'ltr';
  isHe: boolean;
} {
  const lang = language ?? 'en';
  const isHe = lang === 'he' || lang.startsWith('he-');
  const direction: 'rtl' | 'ltr' = isHe ? 'rtl' : 'ltr';

  useEffect(() => {
    document.documentElement.setAttribute('dir', direction);
    document.documentElement.setAttribute('lang', isHe ? 'he' : 'en');
  }, [direction, isHe]);

  return { direction, isHe };
}
